import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import BillingInfo from './BillingInfo'
import AttendeeInfo from './AttendeeInfo'
import { useSignup } from './Signup.hooks'
import { useRecaptcha } from '../../hooks/use-recaptcha'
import { getFormattedDateRange } from '../../helpers/date-helpers'

// const answersFoundOutBy = [
//   {
//     value: 'family_and_friends',
//     label: 'Freund/Familie',
//   },
//   {
//     value: 'facebook',
//     label: 'Facebook',
//   },
//   {
//     value: 'instagram',
//     label: 'Instagram',
//   },
//   {
//     value: 'youtube',
//     label: 'YouTube',
//   },
//   {
//     value: 'newsletter',
//     label: 'Newsletter',
//   },
//   {
//     value: 'flyer',
//     label: 'Flyer',
//   },
//   {
//     value: 'poster',
//     label: 'Poster',
//   },
//   {
//     value: 'searchengine',
//     label: 'Suchmaschine',
//   },
//   {
//     value: 'other',
//     label: 'Sonstiges',
//   },
// ]

const StepSummary = () => {
  const { attendees, setView, loading, error, submit, setAdditional, course } =
    useSignup()

  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      acceptTerms: false,
      acceptRegistrationTerms: false,
      note: '',
      // foundOutBy: '',
    },
  })

  const { renderBadge, getToken } = useRecaptcha()

  const formAction = async (form) => {
    const token = getToken()
    setAdditional({
      acceptTerms: true,
      note: form.note,
    })

    submit(token, form)
  }
  const copsUrl = course.copsUrl ?? 'https://www.storl.de/teilnahmebedingungen/'
  const dateRange = getFormattedDateRange(course.startingAt, course.endingAt)
  return (
    <>
      <h4>Anmeldung für {course.name}</h4>
      <p style={{ fontStyle: 'italic' }}>
        {dateRange.sameDay ? (
          <>am {dateRange.from}</>
        ) : (
          <>
            vom {dateRange.from} bis {dateRange.to}
          </>
        )}
      </p>
      <div className="d-flex justify-content-start align-items-baseline mb-2">
        <h4>Rechnungsdetails</h4>
        <Button
          variant="link"
          size="sm"
          style={{ textDecoration: 'none' }}
          onClick={() => setView('billing')}
          disabled={loading}
        >
          bearbeiten
        </Button>
      </div>
      <BillingInfo />
      <div className="d-flex justify-content-start align-items-baseline mt-4 mb-2">
        <h4>Teilnehmer</h4>
        <Button
          variant="link"
          size="sm"
          style={{ textDecoration: 'none' }}
          onClick={() => setView('attendees')}
          disabled={loading}
        >
          bearbeiten
        </Button>
      </div>
      <Row className="gy-3 mb-4">
        {attendees.map((attendee) => (
          <Col xs={12} key={attendee._id}>
            <AttendeeInfo attendee={attendee} />
          </Col>
        ))}
      </Row>

      <Form noValidate onSubmit={handleSubmit(formAction)}>
        {/* <Form.Group className="mt-5">
          <Form.Label>Wie hast du von der Storl Akademie erfahren?</Form.Label>
          <Form.Control as="select" {...register('foundOutBy')}>
            {answersFoundOutBy.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Form.Control>
        </Form.Group> */}
        <Form.Group className="mb-4">
          <Form.Label>
            {course.type.toLowerCase() === 'journey' ? (
              <>
                Teile uns bitte deine gewünschte{' '}
                <strong>Zimmerkategorie</strong> sowie eventuelle{' '}
                <strong>Nahrungsmittelunverträglichkeiten</strong> mit, damit
                wir besser planen können.
              </>
            ) : (
              <>Hast du noch eine Frage oder Anmerkung?</>
            )}
          </Form.Label>
          <Form.Control as="textarea" rows={3} {...register('note')} />
        </Form.Group>
        <Controller
          name="acceptTerms"
          control={control}
          rules={{
            required: true,
          }}
          render={({
            field: { ref, value, onChange, name },
            fieldState: { invalid, error },
          }) => (
            <Form.Group className="mt-3">
              <Form.Check
                type="checkbox"
                id={name}
                ref={ref}
                checked={value}
                onChange={onChange}
                isInvalid={invalid}
                label={
                  <>
                    Ich stimme zu, dass storl.de meine Daten über dieses
                    Formular sammelt. Ich habe die{' '}
                    <a
                      href="https://www.storl.de/datenschutzbelehrung/"
                      target="_blank"
                    >
                      Datenschutzbelehrung
                    </a>{' '}
                    und{' '}
                    <a href="https://www.storl.de/agb/" target="_blank">
                      AGB
                    </a>{' '}
                    gelesen.
                    {invalid && (
                      <p style={{ fontSize: '0.875em', padding: '15px 0' }}>
                        Die Zustimmung ist erforderlich
                      </p>
                    )}
                  </>
                }
              />
              {/* <Form.Group className="mb-2">
              <Form.Check type="checkbox" id={name}>
                <Form.Check.Input
                  ref={ref}
                  type="checkbox"
                  checked={value}
                  onChange={onChange}
                  isInvalid={invalid}
                />
                <Form.Check.Label className="ps-3" htmlFor={name}>
                  Ich stimme zu, dass storl.de meine Daten über dieses Formular
                  sammelt. Ich habe die{' '}
                  <a
                    href="https://www.storl.de/datenschutzbelehrung/"
                    target="_blank"
                  >
                    Datenschutzbelehrung
                  </a>{' '}
                  und{' '}
                  <a href="https://www.storl.de/agb/" target="_blank">
                    AGB
                  </a>{' '}
                  gelesen.
                </Form.Check.Label>
                <Form.Control.Feedback type="invalid">
                  Diese Zustimmung muss gegeben werden.
                </Form.Control.Feedback>
              </Form.Check>
            )}*/}
            </Form.Group>
          )}
        />
        <Controller
          name="acceptRegistrationTerms"
          control={control}
          rules={{
            required: true,
          }}
          render={({
            field: { ref, value, onChange, name },
            fieldState: { invalid },
          }) => (
            <Form.Group className="mt-3">
              <Form.Check
                type="checkbox"
                id={name}
                ref={ref}
                checked={value}
                onChange={onChange}
                isInvalid={invalid}
                label={
                  <>
                    Ich habe die{' '}
                    <a href={copsUrl} target="_blank">
                      Teilnahmebedingungen
                    </a>{' '}
                    gelesen.
                    {invalid && (
                      <p style={{ fontSize: '0.875em', padding: '15px 0' }}>
                        Bitte lese die Teilnahmebedigungen bevor du deine
                        Anmeldung abschickst.
                      </p>
                    )}
                  </>
                }
              />
              {/* <Form.Group>
              <Form.Check type="checkbox" id={name}>
                <Form.Check.Input
                  ref={ref}
                  type="checkbox"
                  checked={value}
                  onChange={onChange}
                  isInvalid={invalid}
                />
                <Form.Check.Label className="ps-3" htmlFor={name}>
                  Ich habe die Teilnahmebedingungen gelesen.
                </Form.Check.Label>
                <Form.Control.Feedback type="invalid">
                  Bitte lese die Teilnahmebedigungen bevor du deine Anmeldung
                  abschickst.
                </Form.Control.Feedback>
              </Form.Check> */}
            </Form.Group>
          )}
        />
        <div className="mt-4 d-flex justify-content-center">
          {renderBadge()}
        </div>
        <div className="d-flex justify-content-center mt-2">
          <Button type="submit" size="lg" disabled={loading}>
            Anmeldung Abschicken
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
          </Button>
        </div>
      </Form>
      {error && <Alert variant="danger">Es ist ein Fehler aufgetreten</Alert>}
    </>
  )
}

export default StepSummary
